import React from 'react';
import { forEach, get } from 'lodash';
import { Login } from '../components/Pages/Login/Login';
import { NotFound } from '../components/Pages/NotFound/NotFound';
import { PAGES } from './pages';

const Dashboard = React.lazy(
    async () =>
        await import('../components/Pages/Dashboard').then(module => ({
            default: module.Dashboard
        }))
);
const Reports = React.lazy(
    async () =>
        await import('../components/Pages/Reports').then(module => ({
            default: module.Reports
        }))
);
const CallHistory = React.lazy(
    async () =>
        await import('../components/Pages/CallHistory/CallHistory').then(module => ({
            default: module.CallHistory
        }))
);
const KeywordManager = React.lazy(
    async () =>
        await import('../components/Pages/Keywords/Keywords').then(module => ({
            default: module.Keywords
        }))
);

const UserManager = React.lazy(
    async () =>
        await import('../components/Pages/UserManager/UserManager').then(module => ({
            default: module.UserManager
        }))
);

const Recovery = React.lazy(
    async () =>
        await import('../components/Pages/Recovery/Recovery').then(module => ({
            default: module.Recovery
        }))
);
const Sales = React.lazy(
    async () =>
        await import('../components/Pages/Sales/Sales').then(module => ({
            default: module.Sales
        }))
);
const KpiManager = React.lazy(
    async () =>
        await import('../components/Pages/KpiManager/KpiManager').then(module => ({
            default: module.KpiManager
        }))
);
const QualityManagement = React.lazy(
    async () =>
        await import('../components/Pages/QualityManagement/QualityManagement').then(module => ({
            default: module.QualityManagement
        }))
);

interface RouteConfig {
    component?: React.ComponentType<any>;
    path?: string;
    confirmLeave?: (state: any, action: any) => string | undefined;
}

const confirmLeave = (state: any, action: any): string | undefined => {
    if (get(state, 'blockNavigation', false) && get(state, 'location.type') !== action.type) {
        return 'blockNavigationDialog';
    }
    return undefined;
};

const ROUTES: Record<string, RouteConfig> = {
    [PAGES.HOME]: {
        path: '/'
    },
    [PAGES.LOGIN]: {
        component: Login,
        path: '/login'
    },
    [PAGES.RECOVERY]: {
        component: Recovery,
        path: '/recovery'
    },
    [PAGES.DASHBOARD]: {
        component: Dashboard,
        path: '/dashboard/:section?'
    },
    [PAGES.REPORTS]: {
        component: Reports,
        path: '/reports'
    },
    [PAGES.NOT_FOUND]: {
        component: NotFound
    },
    [PAGES.KEYWORD_MANAGER]: {
        component: KeywordManager,
        path: '/keyword-manager/:id?'
    },
    [PAGES.USER_MANAGER]: {
        component: UserManager,
        path: '/user-management/:component?/:id?'
    },
    [PAGES.CALL_HISTORY_REDIRECT]: {
        path: '/calls/:callId?'
    },
    [PAGES.CALL_HISTORY_NEW]: {
        component: CallHistory,
        path: '/call-history/:callId?'
    },
    // Old bot-call URLs preserve their call ID when redirected.
    [PAGES.BOT_CALL_HISTORY_REDIRECT]: {
        path: '/bot-calls/:callId?'
    },
    [PAGES.SALES]: {
        component: Sales,
        path: '/sales'
    },
    [PAGES.KPI_MANAGER]: {
        component: KpiManager,
        path: '/kpi-manager'
    },
    [PAGES.QUALITY_MANAGEMENT]: {
        component: QualityManagement,
        path: '/quality-management/:section?/:evaluationId?'
    }
};

forEach(ROUTES, (route, routeName) => {
    if (routeName !== PAGES.HOME && routeName !== PAGES.LOGIN && routeName !== PAGES.RECOVERY) {
        route.confirmLeave = confirmLeave;
    }
});

export { ROUTES };
